import type { FormEvent } from 'react'
import { useState } from 'react'
import { Link } from 'react-router'


import { AuthLayout } from './AuthLayout'
import { Field, FormError, SubmitButton } from './Field'

import { useRequestPasswordReset } from '@/lib/auth/queries'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const reset = useRequestPasswordReset()

  function onSubmit(event: FormEvent) {
    event.preventDefault()
    reset.mutate(email)
  }

  if (reset.isSuccess) {
    return (
      <AuthLayout title="Check your email" subtitle="If that account exists, a reset link is on its way.">
        <p style={{ color: 'var(--color-text-secondary)' }}>
          The link expires in one hour.
        </p>
        <p style={{ marginTop: 'var(--spacing-4)' }}>
          <Link to="/auth/signin">Back to sign in</Link>
        </p>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We'll email you a link."
      footer={<Link to="/auth/signin">Back to sign in</Link>}
    >
      <form onSubmit={onSubmit} noValidate>
        {reset.error && <FormError message={reset.error.message} />}
        <Field
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          autoComplete="email"
          required
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          disabled={reset.isPending}
        />
        <SubmitButton loading={reset.isPending}>Send reset link</SubmitButton>
      </form>
    </AuthLayout>
  )
}
